<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="slide-y-transition">
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="menu = true" v-on="on" class="pt-1 justify-center align-center align-self-center">
            <v-icon>
              {{ filterIcon }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $vuetify.lang.t('$vuetify.map.travelMap.localFilters.tooltip') }}</span>
      </v-tooltip>
    </template>
    <v-card max-width="500" class="fill-height" height="100%">
      <v-card-title><span class="subtitle-2">{{ $vuetify.lang.t(`$vuetify.map.travelMap.localFilters.title`) }}</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="ma-0 pa-0">
        <v-row>
          <v-col>
            <v-card-subtitle class="my-0 py-0">
            <span
              class="font-weight-bold">{{
                $vuetify.lang.t(`$vuetify.map.travelMap.localFilters.sections.${localFiltersFields.DANGEROUS_STATE_FILTERS}`)
              }}
            </span>
            </v-card-subtitle>
            <v-row justify="start" align="center" no-gutters class="mx-0">
              <v-col
                v-for="[field, value] of Object.entries(eventsLocalFilter[localFiltersFields.DANGEROUS_STATE_FILTERS])"
                :key="`criticalState-${field}`"
                cols="1"
                class="mx-6"
              >
                <checkbox-iconed-basic
                  :field="field" :category="localFiltersFields.DANGEROUS_STATE_FILTERS"
                  :emitString="'local-critical-filter-changed'"
                  :icon="criticalIcons[field]" :value="value" :text="localizeState(field)" color="yellow darken-4"
                  @local-critical-filter-changed="$emit('local-critical-filter-changed', $event)">
                </checkbox-iconed-basic>
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <v-card-subtitle class="my-0 py-0">
          <span
            class="font-weight-bold">{{
              $vuetify.lang.t(`$vuetify.map.travelMap.localFilters.sections.${localFiltersFields.USER_STATE_FILTERS}`)
            }}
          </span>
            </v-card-subtitle>
            <v-row justify="start" align="center" no-gutters class="mx-0">
              <v-col
                v-for="[field, value] of Object.entries(eventsLocalFilter[localFiltersFields.USER_STATE_FILTERS])"
                :key="`userState-${field}`"
                cols="1"
                class="mx-6"
              >
                <checkbox-iconed-basic
                  :field="field" :category="localFiltersFields.USER_STATE_FILTERS"
                  :emitString="'local-critical-filter-changed'"
                  :icon="userStateIcon" :value="value" :text="userStates[field].text" :color="userStates[field].color"
                  @local-critical-filter-changed="$emit('local-critical-filter-changed', $event)">
                </checkbox-iconed-basic>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mdiFilterMenu, mdiMapMarker } from '@mdi/js'
import CheckboxIconedBasic from '@/components/map/criticalEventsLocalFilters/checkboxIconedBasic'
import { dangerousStateIcons } from '@/utils/icons'
import { localizeState, stateColor } from '@/models/map/CriticalEvent'
import { localFiltersFields } from '@/models/map/CriticalEventLocalFilters'
import { UserCriticalEventConfirmation } from '@/enum'

const _userStateEntry = (text, color) => ({ text, color })

export default {
  name: 'criticalEventsLocalFiltersMenu',
  components: { CheckboxIconedBasic },
  props: {
    eventsLocalFilter: Object
  },
  data: () => ({
    menu: false,
    filterIcon: mdiFilterMenu,
    userStateIcon: mdiMapMarker,
    criticalIcons: dangerousStateIcons(),
    userStates: {
      [UserCriticalEventConfirmation.UNKNOWN]: _userStateEntry('$vuetify.map.mapHelp.unknownState', stateColor[UserCriticalEventConfirmation.UNKNOWN]),
      [UserCriticalEventConfirmation.IGNORE]: _userStateEntry('$vuetify.map.mapHelp.ignoredState', stateColor[UserCriticalEventConfirmation.IGNORE]),
      [UserCriticalEventConfirmation.APPROVE]: _userStateEntry('$vuetify.map.mapHelp.approvedState', stateColor[UserCriticalEventConfirmation.APPROVE]),
      [UserCriticalEventConfirmation.REJECT]: _userStateEntry('$vuetify.map.mapHelp.rejectedState', stateColor[UserCriticalEventConfirmation.REJECT]),
      [UserCriticalEventConfirmation.RETRAIN]: _userStateEntry('$vuetify.map.mapHelp.retrainedState', stateColor[UserCriticalEventConfirmation.RETRAIN]),
      [UserCriticalEventConfirmation.APPROVED_RETRAIN]: _userStateEntry('$vuetify.map.mapHelp.approvedRetrainedState', stateColor[UserCriticalEventConfirmation.APPROVED_RETRAIN]),
    }
  }),
  created () {
    this['localizeState'] = localizeState
    this['localFiltersFields'] = localFiltersFields
  }
}
</script>

<style scoped>

</style>
